module.exports = __webpack_public_path__ + "img/calendar.f167ca2b.png";